import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef, NgZone } from '@angular/core';
import { SellerApiService } from '../../../service/seller-api.service';
import { finalize } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { Router } from '@angular/router';


interface ContactObj {
  bank_id: string;
  buyer_name: string;
  buyer_email: string;
  buyer_id: string;
}

@Component({
  selector: 'app-common-int-project',
  templateUrl: './common-int-project.component.html',
  styleUrls: ['./common-int-project.component.scss']
})
export class CommonIntProjectComponent implements OnInit, OnChanges {

  @Input() selectedTab;
  @Input() sellerId;
  @Output() activeTabEvent = new EventEmitter<string>();
  isActiveTab: string;
  commonListObject: any = {
    formone: [],
    formtwo: [],
    questionset: []

  };
  commonObject: any = {
    project_name: null,
    sub_category_position: null,
    scope_upload_links: [],
    internal_project_type: 1,
    internal_project_customer: null
  };
  serviceCategories: Array<any> = [];
  buyerdetails: Array<any> = [];
  suggetionBuyerdetails: Array<any> = [];
  customerInfo: any = {};
  displayname = 'safety';
  currentSellerId: number;
  selectedOption: number;
  selectedBuyerInfo: any = {
    buyer_contacts: []
  };
  selectedNewBuyerOption: string;
  isSelectedOrNew: boolean;
  @ViewChild('cutomereditInfoform') cutomereditInfoform: NgForm;
  @ViewChild('internalProjectcustomerform') internalProjectcustomerform: NgForm;
  @ViewChild('openEditCustomer') openEditCustomer: ElementRef;
  @ViewChild('closeBuyerModal') closeBuyerModal: ElementRef;
  @ViewChild('cutomerModalOpen') cutomerModalOpen: ElementRef;
  @ViewChild('privateaddressFeild') privateaddressFeild: ElementRef;
  @ViewChild('privateworkaddressFeild') privateworkaddressFeild: ElementRef;
  contacts: Array<ContactObj> = [];

  @ViewChild('commonInernalScopecomponent') commonscopecomponent;
  @ViewChild('commonInternalDetailscomponent') commondetailscomponent;
  @ViewChild('commonsafetyboxbrowse') commonsafetyboxbrowse;


  searchQuery: string;
  internal_project_type: number;
  isCategoryRequired: boolean;
  iscustomernamerequired: boolean;
  isbankIdAlreadyExist: boolean;
  loaderActivate: boolean;
  isBankIdRequired: boolean;
  constructor(private sellerService: SellerApiService, private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone, private router: Router) { }

  ngOnInit() {
    this.isActiveTab = 'CustomerInfo';
    this.selectedOption = 1;
    this.selectedNewBuyerOption = 'private';
    this.selectedTab = this.isActiveTab;
    this.loadServiceCategories();
    this.internal_project_type = 1;
   // this.loaderActivate = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isActiveTab = this.selectedTab;
    this.currentSellerId = this.sellerId;
    if (this.currentSellerId != null) {
      this.loadBuyerDetails(this.currentSellerId);
    }
  }

  // On Selection Option || Internal project select option
  OnSelectionInternalProjectOption(value) {
    if (value === 2) {
      this.isBankIdRequired = true;
    }else {
      this.isBankIdRequired = false;
    }
    this.selectedOption = value;
    this.commonObject.internal_project_type = value;
    this.internal_project_type = value;
  }

  // Load the Customer Details
  loadBuyerDetails(sellerId) {
    this.sellerService.getBuyerDetailsBySellerId(sellerId).subscribe(response => {
      this.buyerdetails = response;
      // console.log(this.buyerdetails);
    }, err => {
      console.log(err);
    });
  }

  // Load All the Service categories
  loadServiceCategories() {
    this.sellerService.get_InternalProject_serviceCategory().subscribe(response => {
      this.serviceCategories = response;
    }, err => {
      console.log(err);
    });
  }

  // Selected Buyer Details
  filterCompleSearchMultiple(event) {
    // tslint:disable-next-line:prefer-const
    let query = event.query;
    this.searchQuery = query;
    this.suggetionBuyerdetails = this.filterCommonBuyer(query, this.buyerdetails);
  }
  // Clear values
  onClearAutocomplete(value) {
    this.searchQuery = value;
    // console.log(this.searchQuery);
  }

  filterCommonBuyer(query, buyerinfo: any[]): any[] {
    // tslint:disable-next-line:prefer-const
    let filtered: any[] = [];
    for (let i = 0; i < buyerinfo.length; i++) {
      // tslint:disable-next-line:prefer-const
      let country = buyerinfo[i];
      if (country.buyer_name.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(country);
      }
    }
    return filtered;
  }

  // On select the Buyer Item
  onSelectedSearchBuyer(event) {
    this.isSelectedOrNew = true;
    this.selectedBuyerInfo = event;
    this.searchQuery = this.selectedBuyerInfo.buyer_name;
    this.iscustomernamerequired = false;
  }

  // Modal Buyer Category Add new
  onSelectedBuyerCategory(value) {
    // this.selectedNewBuyerOption = value;
    this.selectedBuyerInfo.account_type = value;
   // this.cutomereditInfoform.form.get('is_work_address_same').setValue(this.selectedBuyerInfo.is_work_address_same);
    // if (this.selectedBuyerInfo.account_type === 1) {
    // }
  }

  // Add customer By
  addNewCustomer() {
    this.iscustomernamerequired = false;
    if (this.internalProjectcustomerform.invalid) {
      this.isCategoryRequired = true;
      return;
    }

    if (this.searchQuery == null || this.searchQuery === '') {
      this.iscustomernamerequired = true;
      return;
    }
    this.isCategoryRequired = false;
    this.selectedBuyerInfo = {
      buyer_contacts: [],
      buyer_id: 0,
      home_address_lat: 0,
      home_address_lon: 0,
      isMainCustomer: true,
      isUpdate: false,
      is_reverse_vat: true,
      work_address_lat: 0,
      work_address_lon: 0,
      reference: null,
      apartment_no: null,
      property_no: null,
      housing_org_no: null
    };
    this.selectedBuyerInfo.buyer_name = this.searchQuery;
    this.selectedBuyerInfo.bank_id = '';
    this.selectedBuyerInfo.buyer_contact_no = '';
    this.selectedBuyerInfo.buyer_email = '';
    this.selectedBuyerInfo.buyer_home_address = '';
    this.selectedBuyerInfo.buyer_work_address = '';
    this.isSelectedOrNew = true;
    this.selectedBuyerInfo.account_type = 1;
    this.selectedBuyerInfo.is_work_address_same = true;
    this.cutomerModalOpen.nativeElement.click();
    setTimeout(() => {
      this.loadAddressComponent();
    }, 2000);
  }

  // Save Changes
  saveChangesBuyerEdit(value, valid) {
    if (this.cutomereditInfoform.invalid) {
      return;
    }
    if (this.isbankIdAlreadyExist) {
      return;
    }
    this.closeBuyerModal.nativeElement.click();
    if (this.selectedBuyerInfo.is_work_address_same) {
      this.selectedBuyerInfo.buyer_work_address = this.selectedBuyerInfo.buyer_home_address;
      this.selectedBuyerInfo.work_address_lat = this.selectedBuyerInfo.home_address_lat;
      this.selectedBuyerInfo.work_address_lon = this.selectedBuyerInfo.home_address_lon;
    }
  }

  // Open  the Modal
  openToEditCustomer() {
    if (this.selectedBuyerInfo == null) {
      this.selectedBuyerInfo.account_type = 1;
      if (!this.selectedBuyerInfo.is_work_address_same) {
        setTimeout(() => {
          this.loadWorkerAddressComponent();
        }, 1000);
      }
      setTimeout(() => {
        this.loadAddressComponent();
      }, 2000);
    }
  }
  //  Remove Selected Item
  removeSelectedItem() {
    this.isSelectedOrNew = false;
    this.selectedBuyerInfo = {
      buyer_contacts: []
    };
    this.customerInfo.selectedBuyer = null;
    this.searchQuery = null;
    this.isbankIdAlreadyExist = false;
  }

  callNextScopeView() {
    if (this.internalProjectcustomerform.invalid) {
      this.isCategoryRequired = true;
      return;
    }

    if (this.searchQuery == null || this.searchQuery === '') {
      this.iscustomernamerequired = true;
      return;
    }

    if(this.cutomereditInfoform.invalid) {
      this.iscustomernamerequired = true;
      return;
    }

    if (this.isbankIdAlreadyExist) {
      return;
    }

    this.isCategoryRequired = false;
    this.isActiveTab = 'Scope';
    this.selectedTab = this.isActiveTab;
    this.activeTabEvent.emit(this.isActiveTab);
  }

  // Call next Page By click
  callNextDetailView() {
    if (!this.commonscopecomponent.callValidationScope()) {
      return;
    }
    this.isActiveTab = 'Details';
    this.selectedTab = this.isActiveTab;
    this.activeTabEvent.emit(this.isActiveTab);
  }

  // Onchange Category
  onChangeCategory(value) {
    if (value != null) {
      this.isCategoryRequired = false;
      this.commonObject.service_category_id = value.service_category_id;
      this.commonObject.service_category_name = value.service_category_name;
      if (value.service_category_name !== 'Other') {
        this.commonObject.sub_category_position = 1;
        this.sellerService.getGeneralizedQuestionSet(value.service_category_id, 1).pipe(finalize(() => {
        })).subscribe(response => {
          this.commonListObject = JSON.parse(response.question_set);
          this.commonListObject.formtwo.map((item) => {
            if (item.type === 'multiselect') {
              // this.commonmultiSelectOptions[item.modal] = this.getCommonMultiSelectArray(item.value);
            }
          });

        }, err => {
          console.log(err);
        });
      } else { // Other Category Called
        this.commonObject.sub_category_position = 0;
        this.sellerService.getGeneralizedQuestionSet(value.service_category_id, 0).pipe(finalize(() => {
        })).subscribe(response => {
          this.commonListObject = JSON.parse(response.question_set);
          this.commonListObject.formtwo.map((item) => {
            if (item.type === 'multiselect') {
              // this.commonmultiSelectOptions[item.modal] = this.getCommonMultiSelectArray(item.value);
            }
          });

        }, err => {
          console.log(err);
        });
      }
    } else {
      this.isCategoryRequired = true;
    }

  }


  // Add Contacts By Adding one By one
  callAddContacts() {
    this.selectedBuyerInfo.buyer_contacts.push({
      buyer_id: this.selectedBuyerInfo.buyer_id,
      buyer_name: '',
      buyer_email: '',
      bank_id: '',
      account_type: 0,
      apartment_no: null,
      buyer_contact_no: null,
      buyer_contacts: null,
      buyer_home_address: null,
      buyer_work_address: null,
      home_address_lat: 0,
      home_address_lon: 0,
      housing_org_no: null,
      isMainCustomer: false,
      isUpdate: false,
      is_reverse_vat: false,
      is_work_address_same: false,
      property_no: null,
      reference: null,
      work_address_lat: 0,
      work_address_lon: 0,
      contact_id: 0
    });
  }

  // Delete Contacts By index
  deleteContactsByIndex(index) {
    this.selectedBuyerInfo.buyer_contacts.splice(index, 1);
  }

  // Onchange Addresss
  handleChange(evt) {
    if (!this.selectedBuyerInfo.is_work_address_same) {
      setTimeout(() => {
        this.loadWorkerAddressComponent();
      }, 1000);
    }
  }

  // Call the Create the Internal project
  callInternalProjectSave() {
    if (this.currentSellerId != null) {
      this.commonObject.seller_id = this.currentSellerId;
      // tslint:disable-next-line:prefer-const
      let obj1 = Object.assign(this.commonObject, this.commonscopecomponent.commonObject);
      // tslint:disable-next-line:prefer-const
      let finalObj = Object.assign(obj1, this.commondetailscomponent.commonObject);
      finalObj.buyer_invitation_link = 'https://yossobuyer.ascentic.se/buyer/join/project';
      finalObj.internal_project_customer = this.selectedBuyerInfo;


      this.commonListObject.formtwo.map((item) => {
        if (item.type === 'multiselect') {
          if (this.commondetailscomponent.commonmultiSelect[item.modal] != null &&
            this.commondetailscomponent.commonmultiSelect.hasOwnProperty(item.modal)) {
            finalObj[item.modal] = this.commondetailscomponent.commonmultiSelect[item.modal].map(function (val) {
              return val['name'];
            }).toString();
          }
        }
      });

     // console.log(JSON.stringify(finalObj));
      this.loaderActivate = true;
      this.sellerService.saveInternalProjectByManageProjects(this.commonsafetyboxbrowse.scope_upload_links, finalObj).finally(() => {
       this.loaderActivate = false;
      }).subscribe(res => {
       // console.log(res);
        if (this.internal_project_type === 1) {
          this.router.navigate(['seller/safetybox'],
          { queryParams: { requesttype: 'activeProjects', selectedtab: 'overview', projectid: res.project_id } });
        }else {
          this.router.navigate(['seller/safetybox'],
          { queryParams: { requesttype: 'main', selectedtab: 'agreement', projectid: res.project_id } });
        }

      }, err => {
        console.log(err);
      });


    }

  }



  loadAddressComponent() {

    if (this.privateaddressFeild) {
      // load Places Autocomplete
      this.mapsAPILoader.load().then(() => {
        // tslint:disable-next-line:prefer-const
        let autocomplete = new google.maps.places.Autocomplete(this.privateaddressFeild.nativeElement, {
          types: ['address'], componentRestrictions: { country: 'SE' }
        });

        autocomplete.addListener('place_changed', () => {
          this.ngZone.run(() => {
            // get the place result
            // tslint:disable-next-line:prefer-const
            let place: google.maps.places.PlaceResult = autocomplete.getPlace();

            // verify result
            if (place.geometry === undefined || place.geometry === null) {

              return;
            }

            this.selectedBuyerInfo.buyer_home_address = place.formatted_address;
            // set latitude, longitude and zoom
            this.selectedBuyerInfo.home_address_lat = place.geometry.location.lat();
            this.selectedBuyerInfo.home_address_lon = place.geometry.location.lng();
          });
        });
      });
    }

  }

  // Check bank Id validation
  checkValidationforBankId(value) {
    if (value != null && value !== '') {
      this.sellerService.getValidateBankIdForInternalProject(value).subscribe(res => {
        if (res != null) {
          this.isbankIdAlreadyExist = res;
        }
      }, err => {
        console.log(err);
      });
    }
  }


  loadWorkerAddressComponent() {

    if (this.privateworkaddressFeild) {
      // load Places Autocomplete
      this.mapsAPILoader.load().then(() => {
        // tslint:disable-next-line:prefer-const
        let autocomplete = new google.maps.places.Autocomplete(this.privateworkaddressFeild.nativeElement, {
          types: ['address'], componentRestrictions: { country: 'SE' }
        });

        autocomplete.addListener('place_changed', () => {
          this.ngZone.run(() => {
            // get the place result
            // tslint:disable-next-line:prefer-const
            let place: google.maps.places.PlaceResult = autocomplete.getPlace();

            // verify result
            if (place.geometry === undefined || place.geometry === null) {

              return;
            }

            this.selectedBuyerInfo.buyer_work_address = place.formatted_address;
            // set latitude, longitude and zoom
            this.selectedBuyerInfo.work_address_lat = place.geometry.location.lat();
            this.selectedBuyerInfo.work_address_lon = place.geometry.location.lng();
          });
        });
      });
    }

  }


  // Address validare
  onaddressValidateGoogle() {
    // load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      // tslint:disable-next-line:prefer-const
      let autocomplete = new google.maps.places.Autocomplete(this.privateaddressFeild.nativeElement, {
        types: ['address'], componentRestrictions: { country: 'SE' }
      });
      this.commonObject.lat = null;
      this.commonObject.lon = null;
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          // tslint:disable-next-line:prefer-const
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          this.selectedBuyerInfo.buyer_home_address = place.formatted_address;
          // set latitude, longitude and zoom
          this.selectedBuyerInfo.home_address_lat = place.geometry.location.lat();
          this.selectedBuyerInfo.home_address_lon = place.geometry.location.lng();
          return;
        });
      });
    });
  }


  // Address validare
  onaddressWorkValidateGoogle() {
    // load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      // tslint:disable-next-line:prefer-const
      let autocomplete = new google.maps.places.Autocomplete(this.privateworkaddressFeild.nativeElement, {
        types: ['address'], componentRestrictions: { country: 'SE' }
      });
      this.commonObject.lat = null;
      this.commonObject.lon = null;
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          // tslint:disable-next-line:prefer-const
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          this.selectedBuyerInfo.buyer_work_address = place.formatted_address;
          // set latitude, longitude and zoom
          this.selectedBuyerInfo.work_address_lat = place.geometry.location.lat();
          this.selectedBuyerInfo.work_address_lon = place.geometry.location.lng();
          return;
        });
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/seller/sub-component/internal-project/common-int-project/common-int-project.component.ts